import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import BudgetSectionForm from '../../../../ReusableFormSections/reusableBudgetSections/Dv360CampaignBudgetSection/BudgetSectionForm'
import BudgetSectionPreview from '../../../../ReusableFormSections/reusableBudgetSections/Dv360CampaignBudgetSection/BudgetSectionPreview'
import ImpressionsBudgetSectionPreview from './CampaignImpressionsBudgetSection/ImpressionsBudgetSectionPreview'
import ImpressionsBudgetSectionForm from './CampaignImpressionsBudgetSection/ImpressionsBudgetSectionForm'
import NameSectionPreview from '../../../../ReusableFormSections/NameSection/NameSectionPreview'
import NameSection from '../../../../DV360/CampaignForms/CampaignDv360Edit/Sections/NameSection'
import DatesSectionForm from '../../../../DV360/CampaignForms/CampaignDv360Edit/Sections/DatesSection/DatesSectionForm'
import DatesSectionPreview from '../../../../DV360/CampaignForms/CampaignDv360Edit/Sections/DatesSection/DatesSectionPreview'

import useRightBudgetAndImpressionsCalculation from '../../../UploadAdCreative/useRightBudgetAndImpressionsCalculation'

import { combinedCampaignsSelector } from '../../../../../modules/selectors/combinedData'
import { UPDATE_COMBINED_CAMPAIGN } from '../../../../../modules/actions/combinedData'
import { rightSelector } from '../../../../../modules/selectors/rights'

import {
  DIGITAL_ALLOCATION_TYPE_BUDGET,
  DIGITAL_ALLOCATION_TYPE_IMPRESSIONS
} from '../../../Partnerships/RightForms/fields'
import { CAMPAIGN_BUDGET } from '../../../CampaignForms/fields'

export const useDv360CampaignBudgetEditSections = selectedEditItemId => {
  const combinedCampaigns = useSelector(combinedCampaignsSelector)
  const { allocation_type: rightAllocationType } = useSelector(rightSelector)
  const isBudgetAllocationType = rightAllocationType === DIGITAL_ALLOCATION_TYPE_BUDGET
  const isImpressionAllocationType = rightAllocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS

  const { remainingBudget, remainingImpressions } = useRightBudgetAndImpressionsCalculation()

  const { campaigns = [] } = combinedCampaigns
  const selectedCampaign = campaigns.find(campaign => String(campaign.id) === String(selectedEditItemId))

  const campaignBudgetSection = useMemo(() => {
    return {
      sectionName: CAMPAIGN_BUDGET,
      title: 'Budget',
      PreviewComponent: <BudgetSectionPreview campaign={selectedCampaign} />,
      FormComponent: (
        <BudgetSectionForm
          remainingBudget={remainingBudget}
          updateOptions={{
            updateType: UPDATE_COMBINED_CAMPAIGN
          }}
        />
      )
    }
  }, [selectedCampaign, remainingBudget])

  const campaignImpressionsBudgetSection = useMemo(() => {
    return {
      sectionName: 'campaign_budget_impressions',
      title: 'Impression',
      PreviewComponent: <ImpressionsBudgetSectionPreview campaign={selectedCampaign} />,
      FormComponent: (
        <ImpressionsBudgetSectionForm
          remainingImpressions={remainingImpressions}
          updateOptions={{
            updateType: UPDATE_COMBINED_CAMPAIGN
          }}
        />
      )
    }
  }, [selectedCampaign, remainingImpressions])

  const editSections = useMemo(() => {
    return [
      {
        sectionName: 'campaign_name',
        title: 'Name',
        PreviewComponent: <NameSectionPreview name={selectedCampaign.name} />,
        FormComponent: (
          <NameSection
            updateOptions={{
              updateType: UPDATE_COMBINED_CAMPAIGN
            }}
          />
        )
      },
      {
        sectionName: 'dates',
        title: 'Dates',
        PreviewComponent: <DatesSectionPreview campaign={selectedCampaign} />,
        FormComponent: (
          <DatesSectionForm
            campaign={selectedCampaign}
            updateOptions={{
              updateType: UPDATE_COMBINED_CAMPAIGN
            }}
          />
        )
      },
      // campaign budget section,
      ...(isBudgetAllocationType ? [campaignBudgetSection] : []),
      ...(isImpressionAllocationType ? [campaignImpressionsBudgetSection] : [])
    ]
  }, [
    campaignBudgetSection,
    isBudgetAllocationType,
    isImpressionAllocationType,
    campaignImpressionsBudgetSection,
    selectedCampaign
  ])

  return { editSections, sectionsInitialOpenStates: {} }
}
